import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import sabotagelogo from '@/assets/sabotage-logo.png';
import { CheckCircle2 } from 'lucide-react';
import { DEFAULT_AUTHED_HOME } from '@/lib/landingAuthCopy';

const Welcome = () => {
  const navigate = useNavigate();
  const { user, isLoading } = useAuth();

  // Auto-redirect once Supabase processes the confirmation token
  useEffect(() => {
    if (!isLoading && user) {
      const timer = setTimeout(() => navigate(DEFAULT_AUTHED_HOME, { replace: true }), 2000);
      return () => clearTimeout(timer);
    }
  }, [user, isLoading, navigate]);

  return (
    <div className="min-h-screen bg-gradient-dark flex items-center justify-center px-4">
      <Card className="w-full max-w-md border-border bg-card">
        <CardHeader className="text-center space-y-4">
          <div className="flex justify-center">
            <img src={sabotagelogo} alt="Sabotage Fantasy" className="h-20 w-auto" />
          </div>
          <div className="flex justify-center">
            <div className="h-16 w-16 rounded-full bg-primary/15 flex items-center justify-center">
              <CheckCircle2 className="h-8 w-8 text-primary" />
            </div>
          </div>
          <CardTitle className="text-2xl font-bold text-foreground font-display">
            Email Confirmed!
          </CardTitle>
          <CardDescription className="text-muted-foreground">
            {user
              ? 'Redirecting you to the app...'
              : 'Your account has been verified. You\'re ready to start sabotaging.'}
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button className="w-full" onClick={() => navigate(user ? DEFAULT_AUTHED_HOME : '/auth')}>
            {user ? 'Go to App' : 'Sign In'}
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Welcome;
